import React from 'react';
import { motion } from 'framer-motion';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiEye, FiMousePointer, FiStar, FiMessageCircle } = FiIcons;

const GoogleBusinessProfile = ({ client, data }) => {
  const safeData = data || {
    actions: 0, views: 0, rating: 0, newReviews: 0, history: [], reviews: []
  };

  const historyData = safeData.history && safeData.history.length > 0 ? safeData.history : [{ month: 'No Data', actions: 0, views: 0 }];

  const metrics = [
    { title: 'Total Actions', value: safeData.actions, icon: FiMousePointer, color: 'text-blue-600' },
    { title: 'Profile Views', value: safeData.views, icon: FiEye, color: 'text-green-600' },
    { title: 'Review Rating', value: safeData.rating, icon: FiStar, color: 'text-yellow-600' },
    { title: 'New Reviews', value: safeData.newReviews, icon: FiMessageCircle, color: 'text-purple-600' }
  ];

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-bold text-gray-800 mb-2">Google Business Profile</h2>
        <p className="text-gray-600">Local SEO performance</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {metrics.map((metric, index) => (
          <motion.div
            key={metric.title}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className="bg-white rounded-xl shadow-sm border border-gray-200 p-6"
          >
            <div className="flex items-center justify-between mb-4">
              <div className={`w-10 h-10 rounded-lg bg-opacity-10 flex items-center justify-center ${metric.color.replace('text-', 'bg-')}`}>
                <SafeIcon icon={metric.icon} className={`text-lg ${metric.color}`} />
              </div>
            </div>
            <h3 className="text-2xl font-bold text-gray-800 mb-1">{metric.value}</h3>
            <p className="text-sm text-gray-600">{metric.title}</p>
          </motion.div>
        ))}
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4 }}
        className="bg-white rounded-xl shadow-sm border border-gray-200 p-6"
      >
        <h3 className="text-lg font-semibold text-gray-800 mb-4">Actions & Views History</h3>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={historyData}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
            <XAxis dataKey="month" stroke="#6b7280" />
            <YAxis stroke="#6b7280" />
            <Tooltip contentStyle={{ backgroundColor: '#fff', border: '1px solid #e5e7eb', borderRadius: '8px' }} />
            <Line type="monotone" dataKey="actions" stroke="#00A859" strokeWidth={3} name="Actions" />
            <Line type="monotone" dataKey="views" stroke="#002B60" strokeWidth={3} name="Views" />
          </LineChart>
        </ResponsiveContainer>
      </motion.div>
    </div>
  );
};

export default GoogleBusinessProfile;